/**
 *
 * @param {"o_name" | "o_value" | "o_target"} attribute
 * @param {PropertyValueProps} property
 * @param {StepProps | undefined} step
 * @param {TimelineMapProps | undefined} timeline
 */
const getAttributeString = (attribute, property, step, timeline) => {
  return (
    property.get(attribute) ||
    step?.get(attribute) ||
    timeline?.get(attribute) ||
    ""
  );
};

export default getAttributeString;
